import jwtAuthAxios from "../auth/jwtAuth";
import { setBackendDomain } from "./management";

const BASE = "/api/v1/access-system/posUsers";

export function normalizePosUsersList(data) {
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  if (Array.isArray(data?.posUsers)) return data.posUsers;
  return [];
}

export function resolvePosUserId(user) {
  if (!user || typeof user !== "object") return null;
  const raw = user._id ?? user.id ?? user.userId;
  if (raw === null || raw === undefined) return null;
  const s = String(raw).trim();
  return s.length ? s : null;
}

export async function listPosUsers() {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.get(BASE);
  return normalizePosUsersList(data);
}

export async function getPosUserById(userId) {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(String(userId).trim());
  const { data } = await jwtAuthAxios.get(`${BASE}/${safeId}`);
  return data;
}

export async function createPosUser(payload) {
  setBackendDomain(jwtAuthAxios);
  const { data } = await jwtAuthAxios.post(BASE, payload);
  return data;
}

export async function updatePosUser(userId, payload) {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(String(userId).trim());
  const { data } = await jwtAuthAxios.put(`${BASE}/${safeId}`, payload);
  return data;
}

export async function deletePosUser(userId) {
  setBackendDomain(jwtAuthAxios);
  const safeId = encodeURIComponent(String(userId).trim());
  const { data } = await jwtAuthAxios.delete(`${BASE}/${safeId}`);
  return data;
}
